<div class="trailer-swap-source-details" [formGroup]="detailsForm">
  <sc-sub-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.step.title.trailer-swap-source-details'"></sc-dictionary-label>
  </sc-sub-title>

  @if (trailerNumberPlateRequired) {
    <div class="row">
      <mat-form-field  class="col first" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.trailerNumberPlate"></sc-dictionary-label>
        </mat-label>
        <input matInput name="trailerNumberPlate" formControlName="trailerNumberPlate"
          [maxlength]="255" [required]="true">
        </mat-form-field>
      </div>
    }
    <div class="row">
      <mat-form-field  class="col first" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.swapTrailerNumber"></sc-dictionary-label>
        </mat-label>
        <input matInput name="swapTrailerNumber" formControlName="swapTrailerNumber"
          [maxlength]="255" [required]="swapTrailerNumberRequired">
        </mat-form-field>
      </div>
    </div>
